import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { coerceNumberProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'mcrai-progress',
  template: `<div
  class="mcrai-progress__bar"
  [ngStyle]="getCurrentTransform()"
></div>
<div class="mcrai-progress__value">
  {{ getCurrentPercent() }}
</div>
`,
  styles: [`.mcrai-progress{display:flex;flex:1;overflow:hidden;position:relative}.mcrai-progress__bar{width:100%;height:27px;background-color:#001435;-webkit-transform-origin:top left;transform-origin:top left;transition:-webkit-transform 250ms;transition:transform 250ms;transition:transform 250ms,-webkit-transform 250ms;transition-timing-function:cubic-bezier(.25,.8,.25,1)}.mcrai-progress__value{position:absolute;top:0;left:10px;line-height:27px;vertical-align:middle}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.mcrai-progress]': 'true'
  }
})
export class ProgressComponent implements OnInit {
  @HostBinding('class.mcrai-progress--primary') _cssColorPrimary = true;
  @HostBinding('class.mcrai-progress--secondary') _cssColorSecondary = true;

  @Input() set current(value: any) {
    this._current = coerceNumberProperty(value);
  }

  @Input() set total(value: any) {
    this._total = coerceNumberProperty(value);
  }

  @Input() set color(value: string) {
    switch (value) {
      case 'primary':
        this._cssColorPrimary = true;
        this._cssColorSecondary = false;
        break;
      case 'secondary':
        this._cssColorPrimary = false;
        this._cssColorSecondary = true;
        break;
      default:
        this._cssColorPrimary = false;
        this._cssColorSecondary = false;
        break;
    }
  }

  private _current: number;
  private _total: number;

  constructor() { }

  ngOnInit() { }

  public getCurrent(): number {
    return (this._current / this._total) || 0;
  }

  public getCurrentPercent(): string {

    return `${(this.getCurrent() * 100).toFixed(2)}%`;
  }

  public getCurrentTransform() {
    return { transform: `scaleX(${this.getCurrent()})` };
  }

}
